import { Component, Input, OnInit } from '@angular/core';
import { BlockUI, NgBlockUI }       from 'ng-block-ui';
import { NgForm }                   from '@angular/forms';
import { TranslateService }         from '@ngx-translate/core';
import { UIRouter }                 from '@uirouter/core';

import { CompanyIntegrationsModel } from '../companies/models/company.integrations';
import { CompanyService }           from '../companies/company.service';
import { MessagesService }          from '../messages/messages.service';
import { SessionService }           from '../sessions/session.service';
import { VVGarageLocationModel }    from './typings/vv-garage.location';
import { VVGarageService }          from './vv-garage.service';

@Component({
  selector   : 'wor-vv-garage-settings',
  template: require('./vv-garage.settings.component.html')
})
export class VVGarageSettingsComponent implements OnInit {
  @BlockUI('vvGarageSettingsBlock') block: NgBlockUI;

  @Input() settings : CompanyIntegrationsModel;
  @Input() locations: Array<VVGarageLocationModel>;

  title = this.vvGarageService.title;

  location : VVGarageLocationModel = {
    LocationID  : '',
    LocationName: ''
  };

  constructor (
    public  companyService  : CompanyService,
    private messagesService : MessagesService,
    private router          : UIRouter,
    private sessionService  : SessionService,
    private translateService: TranslateService,
    private vvGarageService : VVGarageService
  ) {}

  activate () : void {
    this.vvGarageService.activate()
    .then(() => {
      this.messagesService.show(this.translateService.instant('JS_SPACE.INTEGRATIONS.ACTIVATED', {
        name: this.title
      }), 'success');

      this.router.stateService.reload();
    })
    .catch(error => this.messagesService.error(error));
  }

  deactivate () : void {
    this.vvGarageService.deactivate()
    .then(() => {
      this.messagesService.show(this.translateService.instant('JS_SPACE.INTEGRATIONS.REMOVED', {
        name: this.title
      }), 'success');

      this.router.stateService.reload();
    })
    .catch(error => this.messagesService.error(error));
  }

  isGoldOrHigher () : boolean {
    return this.sessionService.base().gold_or_higher;
  }

  ngOnInit () : void {
    this.location = this.locations.find(location => location.LocationID == this.settings.vv_garage_location_id )
      || {
        LocationID  : '',
        LocationName: ''
      };
  }

  save ( form : NgForm ) : void {
    this.block.start();

    this.settings.vv_garage_location_id = this.location.LocationID;

    this.vvGarageService.save(this.settings)
    .then(() => {
      this.messagesService.show(this.translateService.instant('JS_SPACE.MESSAGES.SAVED.SAVE_SUCCESSFUL'), 'success');

      this.router.stateService.reload();
    })
    .catch(error => this.messagesService.error(error))
    .finally(() => this.block.stop());;
  }
}
